<template>
    <svg class="mr-2" width="16" height="19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.99 17.65l-1.86-10.6a.88.88 0 00-.85-.73H10.2c.57-.58.93-1.4.93-2.29 0-1.77-1.4-3.2-3.13-3.2a3.18 3.18 0 00-3.13 3.2c0 .9.36 1.7.93 2.3H2.72a.88.88 0 00-.85.73L0 17.66c-.04.25.03.52.2.72.16.2.4.32.66.32h14.26c.26 0 .5-.11.67-.32.16-.2.23-.47.19-.73zM8 2.61c.77 0 1.39.64 1.39 1.42A1.4 1.4 0 018 5.46a1.4 1.4 0 01-1.39-1.43c0-.78.62-1.42 1.39-1.42z"
            fill="#51747D"
        />
    </svg>
</template>
